export default class ClassName {
  public static OPEN = "is-open";
  public static VISIBLE = "is-visible";
}
